export default {"src":"/_next/static/media/tg.c43028cb.svg","height":18,"width":21};